export default "__VITE_ASSET__9a92c820__"